import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';

// Public 
import { HomeComponent } from "./components/home/home.component";
import { MicrobiotaComponent } from "./components/microbiota/microbiota.component";
import { PreguntasFrecuentesComponent } from "./components/preguntas-frecuentes/preguntas-frecuentes.component";
import { ProbioticosComponent } from "./components/probioticos/probioticos.component";
import { ReferenciasComponent } from "./components/referencias/referencias.component";
import { SaludDigestivaComponent } from "./components/salud-digestiva/salud-digestiva.component";
import { AvisoLegalComponent } from "./components/aviso-legal/aviso-legal.component";
import { AvisoPrivacidadComponent } from "./components/aviso-privacidad/aviso-privacidad.component";
import { AvisoFarmacovigilanciaComponent } from "./components/aviso-farmacovigilancia/aviso-farmacovigilancia.component";
import { ProductosComponent } from "./components/productos/productos.component";
import { DiarreaComponent } from "./components/diarrea/diarrea.component";
import { InflamacionComponent } from "./components/inflamacion/inflamacion.component";
import { EstrenimientoComponent } from "./components/estrenimiento/estrenimiento.component";
import { FloraIntestinalComponent } from "./components/flora-intestinal/flora-intestinal.component";
import { ColitisComponent } from "./components/colitis/colitis.component";
import { MapaSitioComponent } from './components/mapa-sitio/mapa-sitio.component';
import { CookiePolicyComponent } from './components/cookie-policy/cookie-policy.component';
import { notFoundComponent } from './components/error/error-404.component';

// Private

// Services

const routes: Routes = [
  { path: '', component: HomeComponent },
  { path: 'productos', component: ProductosComponent },
  { path: 'microbiota', component: MicrobiotaComponent },
  { path: 'preguntas-frecuentes', component: PreguntasFrecuentesComponent },
  { path: 'probioticos', component: ProbioticosComponent },
  { path: 'terminos-y-condiciones', component: AvisoLegalComponent },
  { path: 'aviso-privacidad', component: AvisoPrivacidadComponent },
  { path: 'aviso-farmacovigilancia', component: AvisoFarmacovigilanciaComponent },
  { path: 'mapa-de-sitio', component: MapaSitioComponent },
  { path: 'referencias', component: ReferenciasComponent },
  { path: 'salud-digestiva', component: SaludDigestivaComponent },
  { path: 'salud-digestiva/diarrea', component: DiarreaComponent },
  { path: 'salud-digestiva/inflamacion', component: InflamacionComponent },
  { path: 'salud-digestiva/estrenimiento', component: EstrenimientoComponent },
  { path: 'salud-digestiva/colitis', component: ColitisComponent },
  { path: 'flora-intestinal', component: FloraIntestinalComponent },
  { path: 'cookie-policy', component: CookiePolicyComponent },
  { path: 'error-404', component: notFoundComponent },
  { path: '**', redirectTo: 'error-404' },
];

export const routedComponents = RouterModule.forRoot(routes);
